import {Action, ActionsVisualData} from '../Actions';
import {
	StateVisualBuilding,
	StateVisualData,
	StateVisualFloor,
	StateVisualOverview,
	StateVisualSection,
	StateVisualStep,
} from '../State';

type PartialStateVisualData = Pick<StateVisualData, keyof StateVisualData>;

function setOverview(
	overview: StateVisualOverview,
): Action<typeof ActionsVisualData>
{
	return {
		type: ActionsVisualData.VISUAL_DATA$_SET_OVERVIEW,
		payload: {
			overview,
		} as PartialStateVisualData,
	};
}

function setBuilding(
	building: StateVisualBuilding,
): Action<typeof ActionsVisualData>
{
	return {
		type: ActionsVisualData.VISUAL_DATA$_SET_BUILDING,
		payload: {
			building,
		} as PartialStateVisualData,
	};
}

function setSection(
	section: StateVisualSection,
): Action<typeof ActionsVisualData>
{
	return {
		type: ActionsVisualData.VISUAL_DATA$_SET_SECTION,
		payload: {
			section,
		} as PartialStateVisualData,
	};
}

function setFloor(
	floor: StateVisualFloor,
): Action<typeof ActionsVisualData>
{
	return {
		type: ActionsVisualData.VISUAL_DATA$_SET_FLOOR,
		payload: {
			floor,
		} as PartialStateVisualData,
	};
}

function setStep(
	step: StateVisualStep,
): Action<typeof ActionsVisualData>
{
	return {
		type: ActionsVisualData.VISUAL_DATA$_SET_STEP,
		payload: {
			step,
		} as PartialStateVisualData,
	};
}

/**
 * Установить состояние подсказки.
 * 
 * @param title Заголовок
 * @param content Содержимое
 * @param visible Показывать?
 */
function setTooltip(
	title: string | JSX.Element | Array<string | JSX.Element>,
	content: string | JSX.Element | Array<string | JSX.Element>,
	visible: boolean = true,
): Action<typeof ActionsVisualData>
{
	return {
		type: ActionsVisualData.VISUAL_DATA$_SET_TOOLTIP,
		payload: {
			title,
			content,
			visible,
		},
	};
}

/**
 * Установить видимость подсказки.
 * 
 * @param visible Показывать?
 */
function setTooltipVisibility(
	visible: boolean,
): Action<typeof ActionsVisualData>
{
	return {
		type: ActionsVisualData.VISUAL_DATA$_SET_TOOLTIP,
		payload: {
			visible,
		},
	};
}

/**
 * Установить видимость фильтра.
 * 
 * @param filterVisible Показывать?
 */
function setFilterVisibility(
	filterVisible: boolean,
): Action<typeof ActionsVisualData>
{
	return {
		type: ActionsVisualData.VISUAL_DATA$_SET_FILTER_VISIBLE,
		payload: {
			filterVisible,
		},
	};
}

/**
 * Module.
 */
export {
	setOverview,
	setBuilding,
	setSection,
	setFloor,
	setStep,
	setTooltip,
	setTooltipVisibility,
	setFilterVisibility,
};



// WEBPACK FOOTER //
// ./app/Routes/Choose/App/Store/creators/visualData.ts